module.exports = __webpack_public_path__ + "assets/gif.gif";


//////////////////
// WEBPACK FOOTER
// ./images/gif.gif
// module id = 564
// module chunks = 0